import { defineAsyncComponent } from 'vue';
import { mountApp, app } from '@/js/app-entries/app-entry-points/global';

const SubscribeAirdropsForm = defineAsyncComponent(() => import('@/js/subscribe/SubscribeAirdropsForm.vue'));
const SubscribeCourseSection = defineAsyncComponent(() => import('@/js/subscribe/SubscribeCourseSection.vue'));

app.component('SubscribeAirdropsForm', SubscribeAirdropsForm);
app.component('SubscribeCourseSection', SubscribeCourseSection);

mountApp();
